import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BragAI from './components/BragAI';
import CaseStudiesPage from './components/CaseStudiesPage';
import UseCasesPage from './components/UseCasesPage';
import AIDiscoveryPage from './components/AIDiscoveryPage';
import BlogPage from './components/BlogPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<BragAI />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/use-cases" element={<UseCasesPage />} />
          <Route path="/ai-discovery" element={<AIDiscoveryPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;